module.exports = __webpack_public_path__ + "img/icon-24-ic-chev-e.74b14279.svg";